import { useQuery } from 'react-query'

import { QUERY_KEYS } from '../../api'
import RailcarApi from './api'

const useFileTypes = () => {
  const { data: railCarFileTypes, isLoading: railCarFileTypesIsLoading } = useQuery(
    [QUERY_KEYS.RAILCAR_FILE_TYPE],
    RailcarApi.getAllFileTypes,
    {
      staleTime: Infinity,
    },
  )

  return {
    railCarFileTypes,
    railCarFileTypesIsLoading,
  }
}

export { useFileTypes }
